var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ReferenciaObraService } from '../../../services/referenciaObraService';
import { FaseService } from '../../../services/faseService';
import { EstadoObraService } from '../../../services/estadoObraService';
import { TipoObraService } from '../../../services/tipoObraService';
import { EmpresaService } from '../../../services/empresaService';
import { ObraService } from '../../../services/obraService';
export var ObrasMixin = {
    data: function () {
        return {
            guardando: false,
            obra: {
                direccion: '',
                referenciaExterna: '',
                idReferenciaObra: null,
                idFase: null,
                municipio: '',
                codigoPostal: '',
                descripcion: '',
                idEstadoObra: null,
                provincia: '',
                idTipoObra: null,
                fechaInicioObra: '',
                fechaFinObra: '',
                magnitudes: '',
                idEmpresa: null
            },
            // Catálogos para los selects
            referenciasObras: [],
            fases: [],
            estadosObras: [],
            tiposObras: [],
            empresas: []
        };
    },
    mounted: function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cargarCatalogos()];
                    case 1:
                        _a.sent();
                        this.preseleccionarEmpresa();
                        return [2 /*return*/];
                }
            });
        });
    },
    methods: {
        cargarCatalogos: function () {
            return __awaiter(this, void 0, Promise, function () {
                var _a, _b, _c, _d, _e, error_1;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            _f.trys.push([0, 6, , 7]);
                            // Cargar referencias de obras
                            _a = this;
                            return [4 /*yield*/, this.obtenerReferenciasObras()
                                // Cargar fases
                            ];
                        case 1:
                            // Cargar referencias de obras
                            _a.referenciasObras = _f.sent();
                            // Cargar fases
                            _b = this;
                            return [4 /*yield*/, this.obtenerFases()
                                // Cargar estados de obras
                            ];
                        case 2:
                            // Cargar fases
                            _b.fases = _f.sent();
                            // Cargar estados de obras
                            _c = this;
                            return [4 /*yield*/, this.obtenerEstadosObras()
                                // Cargar tipos de obras
                            ];
                        case 3:
                            // Cargar estados de obras
                            _c.estadosObras = _f.sent();
                            // Cargar tipos de obras
                            _d = this;
                            return [4 /*yield*/, this.obtenerTiposObras()
                                // Cargar empresas
                            ];
                        case 4:
                            // Cargar tipos de obras
                            _d.tiposObras = _f.sent();
                            // Cargar empresas
                            _e = this;
                            return [4 /*yield*/, this.obtenerEmpresas()];
                        case 5:
                            // Cargar empresas
                            _e.empresas = _f.sent();
                            return [3 /*break*/, 7];
                        case 6:
                            error_1 = _f.sent();
                            console.error('Error cargando catálogos:', error_1);
                            this.$toast({
                                component: { template: '<div>Error cargando datos de catálogos</div>' },
                                props: { variant: 'danger' },
                            });
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerReferenciasObras: function () {
            return __awaiter(this, void 0, Promise, function () {
                var referencias, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, ReferenciaObraService.getAll()];
                        case 1:
                            referencias = _a.sent();
                            return [2 /*return*/, referencias.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); })];
                        case 2:
                            error_2 = _a.sent();
                            console.error('Error obteniendo referencias de obras:', error_2);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerFases: function () {
            return __awaiter(this, void 0, Promise, function () {
                var fases, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, FaseService.getAll()];
                        case 1:
                            fases = _a.sent();
                            return [2 /*return*/, fases.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); })];
                        case 2:
                            error_3 = _a.sent();
                            console.error('Error obteniendo fases:', error_3);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerEstadosObras: function () {
            return __awaiter(this, void 0, Promise, function () {
                var estados, error_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, EstadoObraService.getAll()];
                        case 1:
                            estados = _a.sent();
                            return [2 /*return*/, estados.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); })];
                        case 2:
                            error_4 = _a.sent();
                            console.error('Error obteniendo estados de obras:', error_4);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerTiposObras: function () {
            return __awaiter(this, void 0, Promise, function () {
                var tipos, error_5;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, TipoObraService.getAll()];
                        case 1:
                            tipos = _a.sent();
                            return [2 /*return*/, tipos.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); })];
                        case 2:
                            error_5 = _a.sent();
                            console.error('Error obteniendo tipos de obras:', error_5);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerEmpresas: function () {
            return __awaiter(this, void 0, Promise, function () {
                var empresas, error_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, EmpresaService.getAll()];
                        case 1:
                            empresas = _a.sent();
                            return [2 /*return*/, empresas.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); })];
                        case 2:
                            error_6 = _a.sent();
                            console.error('Error obteniendo empresas:', error_6);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        preseleccionarEmpresa: function () {
            // Verificar si hay un parámetro de empresa en la query
            var empresaId = this.$route.query.empresa;
            if (empresaId && this.empresas.length > 0) {
                var idEmpresa_1 = parseInt(empresaId, 10);
                if (!isNaN(idEmpresa_1)) {
                    // Verificar que la empresa existe en la lista
                    var empresaExiste = this.empresas.some(function (empresa) { return empresa.idEmpresa === idEmpresa_1; });
                    if (empresaExiste) {
                        this.obra.idEmpresa = idEmpresa_1;
                        console.log("Empresa preseleccionada: ".concat(idEmpresa_1));
                    }
                }
            }
        },
        validarFormulario: function () {
            var camposRequeridos = [
                'direccion', 'idFase', 'municipio', 'codigoPostal',
                'idEstadoObra', 'provincia', 'idTipoObra',
                'fechaInicioObra', 'idEmpresa'
            ];
            for (var _i = 0, camposRequeridos_1 = camposRequeridos; _i < camposRequeridos_1.length; _i++) {
                var campo = camposRequeridos_1[_i];
                if (!this.obra[campo]) {
                    this.$toast({
                        component: { template: "<div>El campo ".concat(campo, " es requerido</div>") },
                        props: { variant: 'warning' },
                    });
                    return false;
                }
            }
            // Validar que la fecha de fin sea posterior a la de inicio (solo si ambas fechas están presentes)
            if (this.obra.fechaFinObra && this.obra.fechaInicioObra) {
                if (new Date(this.obra.fechaInicioObra) >= new Date(this.obra.fechaFinObra)) {
                    this.$toast({
                        component: { template: '<div>La fecha de fin debe ser posterior a la fecha de inicio</div>' },
                        props: { variant: 'warning' },
                    });
                    return false;
                }
            }
            return true;
        },
        guardarObra: function () {
            return __awaiter(this, void 0, Promise, function () {
                var obraData, error_7, axiosError;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.validarFormulario()) {
                                return [2 /*return*/];
                            }
                            this.guardando = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            obraData = {
                                idObra: null,
                                direccion: this.obra.direccion,
                                referenciaExterna: this.obra.referenciaExterna || undefined,
                                idReferenciaObra: this.obra.idReferenciaObra,
                                idFase: this.obra.idFase,
                                municipio: this.obra.municipio,
                                codigoPostal: this.obra.codigoPostal,
                                descripcion: this.obra.descripcion || undefined,
                                idEstadoObra: this.obra.idEstadoObra,
                                provincia: this.obra.provincia,
                                idTipoObra: this.obra.idTipoObra,
                                fechaInicioObra: this.obra.fechaInicioObra,
                                fechaFinObra: this.obra.fechaFinObra || undefined,
                                magnitudes: this.obra.magnitudes || undefined,
                                idEmpresa: this.obra.idEmpresa,
                                ownerId: undefined // Permitir que el backend asigne automáticamente el primer usuario disponible
                            };
                            return [4 /*yield*/, ObraService.create(obraData)];
                        case 2:
                            _a.sent();
                            this.$toast({
                                component: { template: '<div>Obra creada correctamente</div>' },
                                props: { variant: 'success' },
                            });
                            this.$router.push({ name: 'obras-lista' });
                            return [3 /*break*/, 5];
                        case 3:
                            error_7 = _a.sent();
                            console.error('Error guardando obra:', error_7);
                            axiosError = error_7;
                            if (axiosError.response && axiosError.response.status === 400) {
                                this.$toast({
                                    component: { template: '<div>Datos inválidos. Verifique la información ingresada.</div>' },
                                    props: { variant: 'warning' },
                                });
                            }
                            else {
                                this.$toast({
                                    component: { template: '<div>Error al guardar la obra</div>' },
                                    props: { variant: 'danger' },
                                });
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            this.guardando = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        volver: function () {
            this.$router.push({ name: 'obras-lista' });
        },
    },
};
